export { DictionariesComponent } from './dictionaries.component';
export { BlacklistComponent } from './components/blacklist/blacklist.component';
export { SinonimiComponent } from './components/sinonimi/sinonimi.component';
export { StopwordsComponent } from './components/stopwords/stopwords.component';
